import { Injectable } from '@angular/core';
import { DietsModel, DietModel } from 'src/app/core/model/object/diet-model';
import {
  RecentSearchedPackagesModel,
  RecentSearchedPackageModel,
} from 'src/app/core/model/object/diet-food-model';
import { PlanShared } from 'src/app/presentation/general/shared/plan-shared';
import { NgxIndexedDBService } from 'ngx-indexed-db';
import { LogoutService } from '../user-repository/logout.service';
import { IndexDbService } from '../error-boundary/index-db.service';

@Injectable({
  providedIn: 'root',
})
export class DietDataService {
  constructor(
    private planShared: PlanShared,
    private dbService: NgxIndexedDBService,
    private logoutService: LogoutService,
    private errorBoundry: IndexDbService
  ) {}

  public async getDiets(): Promise<DietsModel> {
    if (
      localStorage.getItem('diets') &&
      localStorage.getItem('diets') === '-1'
    ) {
      if (this.planShared.diets) {
        return Promise.resolve(this.planShared.diets);
      } else {
        localStorage.removeItem('diets');
        const dietsJson = localStorage.getItem('diets');
        const diets = DietsModel.fromJSON(dietsJson);
        if (diets) {
          return Promise.resolve(diets);
        }
      }
    } else {
      let diets: DietModel[];
      const response = await this.dbService.getAll('newDiets').then(
        async (ds) => {
          diets = [];
          ds.forEach((diet, i) => {
            const d = new DietModel(
              diet['difficulty'],
              diet['isCanceled'],
              diet['hatedFoods'],
              diet['diseases'],
              diet['pregnancyDate'],
              diet['breastFeedingDate'],
              diet['specialTypes'],
              diet['_id'],
              diet['days'],
              diet['startWeight'],
              diet['activity'],
              diet['startDate'],
              diet['endDate'],
              diet['goal'],
              diet['calorie'],
              diet['updatedAt'],
              diet['createdAt'],
              diet['type'],
              diet['fasting']
            );
            diets.push(d);
          });
          const dietsUpdatedAt = localStorage.getItem('dietsUpdatedAt');
          const dietsModel = new DietsModel(diets, dietsUpdatedAt);
          // alert(JSON.stringify(dietsModel));

          return dietsModel;
        },
        (error) => {
          console.log(error);
          this.errorBoundry.sendIndexDbError('getAll newDiets', error);
          this.logoutService.logout();
          return new DietsModel(null, null);
        }
      );
      return Promise.resolve(response);
    }
  }

  public async saveDiets(res: DietModel[]): Promise<boolean> {
    await this.removeOldDiets();
    // localStorage.setItem('diets', JSON.stringify(new DietsModel(res, new Date().toISOString())));
    this.updateUpdatedAt();

    if (res.length === 0) {
      return Promise.resolve(true);
    }
    const ds = await this.dbService.getAll('newDiets');
    res.forEach(async (diet) => {
      let found = false;
      ds.forEach(async (d) => {
        if (diet._id === d['_id']) {
          found = true;
          this.dbService
            .update('newDiets', {
              id: d['id'],
              difficulty: diet.difficulty,
              isCanceled: diet.isCanceled,
              hatedFoods: diet.hatedFoods,
              diseases: diet.diseases,
              pregnancyDate: diet.pregnancyDate,
              breastFeedingDate: diet.breastFeedingDate,
              specialTypes: diet.specialTypes,
              _id: diet._id,
              days: diet.days,
              startWeight: diet.startWeight,
              activity: diet.activity,
              startDate: diet.startDate,
              endDate: diet.endDate,
              goal: diet.goal,
              calorie: diet.calorie,
              updatedAt: diet.updatedAt,
              createdAt: diet.createdAt,
              type: diet.type,
              fasting: diet.fasting,
            })
            .then(
              () => {},
              (error) => {
                console.log(error);
                this.errorBoundry.sendIndexDbError('update newDiets', error);
              }
            );
        }
      });
      if (!found) {
        this.dbService
          .add('newDiets', {
            difficulty: diet.difficulty,
            isCanceled: diet.isCanceled,
            hatedFoods: diet.hatedFoods,
            diseases: diet.diseases,
            pregnancyDate: diet.pregnancyDate,
            breastFeedingDate: diet.breastFeedingDate,
            specialTypes: diet.specialTypes,
            _id: diet._id,
            days: diet.days,
            startWeight: diet.startWeight,
            activity: diet.activity,
            startDate: diet.startDate,
            endDate: diet.endDate,
            goal: diet.goal,
            calorie: diet.calorie,
            updatedAt: diet.updatedAt,
            dietsUpdatedAt: new Date().toDateString(),
            createdAt: diet.createdAt,
            type: diet.type,
            fasting: diet.fasting,
          })
          .then(
            () => {},
            (error) => {
              console.log(error);
            }
          );
      }
    });
  }

  public async deleteAndSaveDiets(res: DietModel[]): Promise<boolean> {
    // localStorage.setItem('diets', JSON.stringify(new DietsModel(res, new Date().toISOString())));
    await this.removeDiets();
    this.updateUpdatedAt();

    if (res.length === 0) {
      return Promise.resolve(true);
    }
    res.forEach(async (diet) => {
      this.dbService
        .add('newDiets', {
          difficulty: diet.difficulty,
          isCanceled: diet.isCanceled,
          hatedFoods: diet.hatedFoods,
          diseases: diet.diseases,
          pregnancyDate: diet.pregnancyDate,
          breastFeedingDate: diet.breastFeedingDate,
          specialTypes: diet.specialTypes,
          _id: diet._id,
          days: diet.days,
          startWeight: diet.startWeight,
          activity: diet.activity,
          startDate: diet.startDate,
          endDate: diet.endDate,
          goal: diet.goal,
          calorie: diet.calorie,
          updatedAt: diet.updatedAt,
          dietsUpdatedAt: new Date().toDateString(),
          createdAt: diet.createdAt,
          type: diet.type,
          fasting: diet.fasting,
        })
        .then(
          () => {},
          (error) => {
            console.log(error);
          }
        );
    });
  }

  public updateUpdatedAt() {
    localStorage.setItem('dietsUpdatedAt', new Date().toISOString());
    localStorage.setItem('newDietModel', '1');
  }

  public async removeDiets(): Promise<boolean> {
    const response = await this.dbService.clear('newDiets').then(
      () => {
        return true;
        // Do something after clear
      },
      (error) => {
        console.log(error);
        this.logoutService.logout();
        return false;
      }
    );
    return Promise.resolve(response);
  }

  public async removeOldDiets(): Promise<boolean> {
    const response = await this.dbService.clear('diets').then(
      () => {
        return true;
        // Do something after clear
      },
      (error) => {
        console.log(error);
        this.logoutService.logout();
        return false;
      }
    );
    return Promise.resolve(response);
  }
}
